



















































import {
	computed,
	defineComponent,
	PropType,
} from '@vue/composition-api';
import AlignmentButtons from '@front-app/components/inputs/AlignmentButtons.vue';
import { Size } from '@front-app/components/constants';
import { SelectBoxChoice } from '@front-app/components/inputs/SelectBoxModel';
import SelectBox from '@front-app/components/inputs/SelectBox.vue';
import { DropdownPosition } from '@front-app/components/dropdowns/dropdownPosition';
import FormSection from '@front-app/components/form/FormSection.vue';
import BasicTextEditor from '@front-app/components/inputs/BasicTextEditor.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import { HighlightsHeadingComponent } from '../../model';
import { useHighlightsInput } from '../../hooks/useHighlightsInput';
import BaseEditor from '../BaseEditor.vue';

const sizeOptionLabels: Record<Extract<Size, Size.LARGE | Size.MEDIUM>, string> = {
	[Size.LARGE]: 'Large',
	[Size.MEDIUM]: 'Medium',
};

const sizeOptions: SelectBoxChoice[] = [
	{
		key: Size.LARGE,
		label: sizeOptionLabels[Size.LARGE],
	},
	{
		key: Size.MEDIUM,
		label: sizeOptionLabels[Size.MEDIUM],
	},
];

export default defineComponent({
	components: {
		BaseEditor,
		AlignmentButtons,
		BasicTextEditor,
		SelectBox,
		FormSection,
		FormLabel,
	},
	props: {
		value: {
			type: Object as PropType<HighlightsHeadingComponent>,
			required: true,
		},
	},
	setup(props, ctx) {
		const useInput = useHighlightsInput(ctx, computed(() => props.value));
		return {
			doInput: useInput.doInput,
			doMetaInput: useInput.doMetaInput,
			dropdownPosition: DropdownPosition.BOTTOM_RIGHT,
			sizeOptionLabels,
			sizeOptions,
		};
	},
});
